import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { RepoMappingsView } from "@/github-app/components/repo-mappings-view";
import { Skeleton } from "@/shared/ui/skeleton";

export const Route = createFileRoute(
  "/app/organization/$id/settings/repo-mappings"
)({
  loader: async ({ context, params }) => {
    await context.queryClient
      .query(
        context.trpc.githubApp.getRepoMappings.queryOptions(
          {
            organizationId: params.id,
          }
        )
      )
      .catch(() => undefined);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  return (
    <Suspense
      fallback={
        <div className="space-y-4">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-32 w-full" />
        </div>
      }
    >
      <RepoMappingsView organizationId={id} />
    </Suspense>
  );
}
